var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcasting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1947_64922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.773 14.5231C14.717 13.5791 15.3599 12.3763 15.6203 11.067C15.8808 9.75758 15.7471 8.40039 15.2362 7.16699C14.7253 5.93359 13.8601 4.87939 12.7501 4.1377C11.6401 3.396 10.335 3.00012 9 3.00012C7.66498 3.00012 6.35994 3.396 5.24991 4.1377C4.13988 4.87939 3.27472 5.93359 2.76382 7.16699C2.25293 8.40039 2.11925 9.75758 2.3797 11.067C2.64014 12.3763 3.28301 13.5791 4.227 14.5231",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.652 12.4019C12.1764 11.8774 12.5334 11.2092 12.678 10.4818C12.8226 9.75443 12.7483 9.00048 12.4645 8.31532C12.1806 7.63015 11.7 7.04454 11.0833 6.63253C10.4666 6.22052 9.74164 6.00061 9 6.00061C8.25836 6.00061 7.53338 6.22052 6.91672 6.63253C6.30005 7.04454 5.81941 7.63015 5.53555 8.31532C5.25169 9.00048 5.17737 9.75443 5.32198 10.4818C5.4666 11.2092 5.82365 11.8774 6.348 12.4019",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75C8.25 9.94891 8.32902 10.1397 8.46967 10.2803C8.61032 10.421 8.80109 10.5 9 10.5C9.19891 10.5 9.38968 10.421 9.53033 10.2803C9.67098 10.1397 9.75 9.94891 9.75 9.75C9.75 9.55109 9.67098 9.36032 9.53033 9.21967C9.38968 9.07902 9.19891 9 9 9C8.80109 9 8.61032 9.07902 8.46967 9.21967C8.32902 9.36032 8.25 9.55109 8.25 9.75Z",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1947_64922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcasting);
export default __webpack_public_path__ + "static/media/Broadcasting.13ba32131844e2eeeb05e679b3cecb0a.svg";
export { ForwardRef as ReactComponent };